import './privacy.scss'
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import {Helmet} from "react-helmet";
import React from "react";

const Privacy = () => {
  return (
    <>
    <main className='privacy-page typora-export'>
      <Helmet>
        <meta property="title" content="Xerinola - Política de Privacitat" />
        <meta property="title" lang="ca" content="Xerinola - Política de Privacitat" />
        <meta property="title" lang="en" content="Xerinola - Privacy Policy" />
        <meta property="title" lang="es" content="Xerinola - Política de Privacidad" />
        <meta property="og:title" content="Xerinola - Política de Privacitat" />
        <meta property="og:title" lang="ca" content="Xerinola - Política de Privacitat" />
        <meta property="og:title" lang="en" content="Xerinola - Privacy Policy" />
        <meta property="og:title" lang="es" content="Xerinola - Política de Privacidad" />
        <meta property="og:url" content="https://xerinola.io/privacy" />
      </Helmet>
      <Header section="Política de privacitat"/>
      <div className="container">
        <div className='typora-export-content'>
          <div id='write' className=''>
            <p>
              <strong>
                <span>Last updated April 04, 2022</span>
              </strong>
            </p>
            <p>
              <span>This privacy notice for Xerinola (&quot;</span>
              <strong>
                <span>Company</span>
              </strong>
              <span>,&quot; &quot;</span>
              <strong>
                <span>we</span>
              </strong>
              <span>,&quot; &quot;</span>
              <strong>
                <span>us</span>
              </strong>
              <span>,&quot; or &quot;</span>
              <strong>
                <span>our</span>
              </strong>
              <span>&quot;), describes how and why we might collect, store, use, and/or share (&quot;</span>
              <strong>
                <span>process</span>
              </strong>
              <span>&quot;) your information when you use our services (&quot;</span>
              <strong>
                <span>Services</span>
              </strong>
              <span>&quot;), such as when you:</span>
            </p>
            <ul>
              <li>
                <span>Download and use our mobile application (Xerinola), or any other application of ours that links to this privacy notice</span>
              </li>
            </ul>
            <ul>
              <li>
                <span>Engage with us in other related ways, including any sales, marketing, or events</span>
              </li>
            </ul>
            <p>
              <strong>
                <span>Questions or concerns?</span>
              </strong>
              <span> Reading this privacy notice will help you understand your privacy rights and choices. If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us at </span>
              <a href='mailto:hello@rogerserentill.com' target='_blank' rel='noreferrer' className='url'>hello@rogerserentill.com</a>
              <span>.</span>
            </p>
            <p>
              <strong>
                <span>SUMMARY OF KEY POINTS</span>
              </strong>
            </p>
            <p>
              <em>
                <strong>
                  <span>This summary provides key points from our privacy notice, but you can find out more details about any of these topics by clicking the link following each key point or by using our table of contents below to find the section you are looking for.</span>
                </strong>
              </em>
            </p>
            <p>
              <strong>
                <span>What personal information do we process?</span>
              </strong>
              <span> When you visit, use, or navigate our Services, we may process personal information depending on how you interact with Xerinola and the Services, the choices you make, and the products and features you use.</span>
            </p>
            <p>
              <strong>
                <span>Do we process any sensitive personal information?</span>
              </strong>
              <span> We do not process sensitive personal information.</span>
            </p>
            <p>
              <strong>
                <span>Do you receive any information from third parties?</span>
              </strong>
              <span> We do not receive any information from third parties.</span>
            </p>
            <p>
              <strong>
                <span>How do you process my information?</span>
              </strong>
              <span> We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent. We process your information only when we have a valid legal reason to do so. Click </span>
              <a href='#infouse'>
                <span>here</span>
              </a>
              <span> to learn more.</span>
            </p>
            <p>
              <strong>
                <span>In what situations and with which parties do we share personal information?</span>
              </strong>
              <span> We may share information in specific situations and with specific third parties. Click </span>
              <a href='#whoshare'>
                <span>here</span>
              </a>
              <span> to learn more.</span>
            </p>
            <p>
              <strong>
                <span>How do we keep your information safe?</span>
              </strong>
              <span> We have organizational and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Click </span>
              <a href='#infosafe'>
                <span>here</span>
              </a>
              <span> to learn more.</span>
            </p>
            <p>
              <strong>
                <span>What are your rights?</span>
              </strong>
              <span> Depending on where you are located geographically, the applicable privacy law may mean you have certain rights regarding your personal information. Click </span>
              <a href='#privacyrights'>
                <span>here</span>
              </a>
              <span> to learn more.</span>
            </p>
            <p>
              <strong>
                <span>How do I exercise my rights?</span>
              </strong>
              <span> The easiest way to exercise your rights is by filling out our data subject request form available here: </span>
              <a href='http://www.xerinola.io/support' target='_blank' rel='noreferrer' className='url'>http://www.xerinola.io/support</a>
              <span>, or by contacting us. We will consider and act upon any request in accordance with applicable data protection laws.</span>
            </p>
            <p>
              <strong>
                <span>TABLE OF CONTENTS</span>
              </strong>
            </p>
            <p>
              <a href='#infocollect'>
                <span>1. WHAT INFORMATION DO WE COLLECT?</span>
              </a>
            </p>
            <p>
              <a href='#infouse'>
                <span>2. HOW DO WE PROCESS YOUR INFORMATION?</span>
              </a>
            </p>
            <p>
              <a href='#legalbases'>
                <span>3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL INFORMATION?</span>
              </a>
            </p>
            <p>
              <a href='#whoshare'>
                <span>4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</span>
              </a>
            </p>
            <p>
              <a href='#inforetain'>
                <span>5. HOW LONG DO WE KEEP YOUR INFORMATION?</span>
              </a>
            </p>
            <p>
              <a href='#inforetain'>
                <span>6. HOW DO WE KEEP YOUR INFORMATION SAFE?</span>
              </a>
            </p>
            <p>
              <a href='#privacyrights'>
                <span>7. WHAT ARE YOUR PRIVACY RIGHTS?</span>
              </a>
            </p>
            <p>
              <a href='#DNT'>
                <span>8. CONTROLS FOR DO-NOT-TRACK FEATURES</span>
              </a>
            </p>
            <p>
              <a href='#caresidents'>
                <span>9. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</span>
              </a>
            </p>
            <p>
              <a href='#policyupdates'>
                <span>10. DO WE MAKE UPDATES TO THIS NOTICE?</span>
              </a>
            </p>
            <p>
              <a href='#contact'>
                <span>11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
              </a>
            </p>
            <p>
              <a href='#request'>
                <span>12. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</span>
              </a>
            </p>
            <p>
              <strong>
                <span id="infocollect">1. WHAT INFORMATION DO WE COLLECT?</span>
              </strong>
            </p>
            <p>
              <strong>
                <span>Personal information you disclose to us</span>
              </strong>
            </p>
            <p>
              <strong>
                <span>In Short:</span>
              </strong>
              <span></span>
              <em>
                <span>We collect personal information that you provide to us.</span>
              </em>
            </p>
            <p>
              <span>We collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.</span>
            </p>
            <p>
              <strong>
                <span>Personal Information Provided by You.</span>
              </strong>
              <span> The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include the following:</span>
            </p>
            <ul>
              <li>
                <span>phone numbers</span>
              </li>
            </ul>
            <ul>
              <li>
                <span>food preferences</span>
              </li>
            </ul>
            <ul>
              <li>
                <span>food allergies</span>
              </li>
            </ul>
            <p>
              <strong>
                <span>Sensitive Information.</span>
              </strong>
              <span> We do not process sensitive information.</span>
            </p>
            <p>
              <strong>
                <span>Application Data.</span>
              </strong>
              <span> If you use our application(s), we also may collect the following information if you choose to provide us with access or permission:</span>
            </p>
            <ul>
              <li>
                <em>
                  <span>Mobile Device Access.</span>
                </em>
                <span> We may request access or permission to certain features from your mobile device, including your mobile device&#39;s calendar, and other features. If you wish to change our access or permissions, you may do so in your device&#39;s settings.</span>
              </li>
            </ul>
            <ul>
              <li>
                <em>
                  <span>Mobile Device Data.</span>
                </em>
                <span> We automatically collect device model name to help us identify and protect your login session.</span>
              </li>
            </ul>
            <ul>
              <li>
                <em>
                  <span>Push Notifications.</span>
                </em>
                <span> We may request to send you push notifications regarding your account or certain features of the application(s). If you wish to opt out from receiving these types of communications, you may turn them off in your device&#39;s settings.</span>
              </li>
            </ul>
            <p>
              <span>This information is primarily needed to maintain the security and operation of our application(s), for troubleshooting, and for our internal analytics and reporting purposes.</span>
            </p>
            <p>
              <span>All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.</span>
            </p>
            <p>
              <strong>
                <span id="infouse">2. HOW DO WE PROCESS YOUR INFORMATION?</span>
              </strong>
            </p>
            <p>
              <strong>
                <span>In Short:</span>
              </strong>
              <span></span>
              <em>
                <span>We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent.</span>
              </em>
            </p>
            <p>
              <strong>
                <span>We process your personal information for a variety of reasons, depending on how you interact with our Services, including:</span>
              </strong>
            </p>
            <ul>
              <li>
                <strong>
                  <span>To save or protect an individual&#39;s vital interest.</span>
                </strong>
                <span> We may process your information when necessary to save or protect an individuals vital interest, such as to prevent harm.</span>
              </li>
            </ul>
            <p>
              <strong>
                <span id="legalbases">3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?</span>
              </strong>
            </p>
            <p>
              <strong>
                <span>In Short:</span>
              </strong>
              <span> We only process your personal information when we believe it is necessary and we have a valid legal reason (i.e., legal basis) to do so under applicable law, like with your consent, to comply with laws, to provide you with services to enter into or fulfill our contractual obligations, to protect your rights, or to fulfill our legitimate business interests.*</span>
            </p>
            <p>
              <span>The General Data Protection Regulation (GDPR) and UK GDPR require us to explain the valid legal bases we rely on in order to process your personal information. As such, we may rely on the following legal bases to process your personal information:</span>
            </p>
            <ul>
              <li>
                <strong>
                  <span>Consent.</span>
                </strong>
                <span> We may process your information if you have given us permission (i.e., consent) to use your personal information for a specific purpose. You can withdraw your consent at any time. Click </span>
                <a href='#withdrawconsent'>
                  <span>here</span>
                </a>
                <span> to learn more.</span>
              </li>
            </ul>
            <p>&nbsp;</p>
            <ul>
              <li>
                <strong>
                  <span>Legal Obligations.</span>
                </strong>
                <span> We may process your information where we believe it is necessary for compliance with our legal obligations, such as to cooperate with a law enforcement body or regulatory agency, exercise or defend our legal rights, or disclose your information as evidence in litigation in which we are involved.</span>
              </li>
            </ul>
            <ul>
              <li>
                <strong>
                  <span>Vital Interests.</span>
                </strong>
                <span> We may process your information where we believe it is necessary to protect your vital interests or the vital interests of a third party, such as situations involving potential threats to the safety of any person.</span>
              </li>
            </ul>
            <p>
              <strong>
                <span id="whoshare">4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</span>
              </strong>
            </p>
            <p>
              <strong>
                <span>In Short:</span>
              </strong>
              <span> We may share information in specific situations described in this section and/or with the following third parties.*</span>
            </p>
            <p>
              <span>We may need to share your personal information in the following situations:</span>
            </p>
            <ul>
              <li>
                <strong>
                  <span>Business Transfers.</span>
                </strong>
                <span> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.</span>
              </li>
            </ul>
            <p>&nbsp;</p>
            <p>
              <strong>
                <span id="inforetain">5. HOW LONG DO WE KEEP YOUR INFORMATION?</span>
              </strong>
            </p>
            <p>
              <strong>
                <span>In Short:</span>
              </strong>
              <span></span>
              <em>
                <span>We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice unless otherwise required by law.</span>
              </em>
            </p>
            <p>
              <span>We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements).</span>
            </p>
            <p>
              <span>When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.</span>
            </p>
            <p>
              <strong>
                <span id="inforetain">6. HOW DO WE KEEP YOUR INFORMATION SAFE?</span>
              </strong>
            </p>
            <p>
              <strong>
                <span>In Short:</span>
              </strong>
              <span></span>
              <em>
                <span id="infosafe">We aim to protect your personal information through a system of organizational and technical security measures.</span>
              </em>
            </p>
            <p>
              <span>We have implemented appropriate and reasonable technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our Services is at your own risk. You should only access the Services within a secure environment.</span>
            </p>
            <p>
              <strong>
                <span id="privacyrights">7. WHAT ARE YOUR PRIVACY RIGHTS?</span>
              </strong>
            </p>
            <p>
              <strong>
                <span>In Short:</span>
              </strong>
              <span> In some regions, such as the European Economic Area (EEA) and United Kingdom (UK), you have rights that allow you greater access to and control over your personal information.Â You may review, change, or terminate your account at any time.*</span>
            </p>
            <p>
              <span>In some regions (like the EEA and UK), you have certain rights under applicable data protection laws. These may include the right (i) to request access and obtain a copy of your personal information, (ii) to request rectification or erasure; (iii) to restrict the processing of your personal information; and (iv) if applicable, to data portability. In certain circumstances, you may also have the right to object to the processing of your personal information. You can make such a request by contacting us by using the contact details provided in the section </span>
              <a href='#contact'>
                <span>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
              </a>
              <span> below.</span>
            </p>
            <p>
              <span>We will consider and act upon any request in accordance with applicable data protection laws.</span>
            </p>
            <p>
              <span>If you are located in the EEA or UK and you believe we are unlawfully processing your personal information, you also have the right to complain to your local data protection supervisory authority. You can find their contact details here: </span>
              <a href='https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm' target='_blank' rel='noreferrer'
                 className='url'>https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm</a>
              <span>.</span>
            </p>
            <p>
              <span>If you are located in Switzerland, the contact details for the data protection authorities are available here: </span>
              <a href='https://www.edoeb.admin.ch/edoeb/en/home.html' target='_blank' rel='noreferrer'
                 className='url'>https://www.edoeb.admin.ch/edoeb/en/home.html</a>
              <span>.</span>
            </p>
            <p>
              <strong>
                <span id="withdrawconsent">Withdrawing your consent:</span>
              </strong>
              <span> If we are relying on your consent to process your personal information, you have the right to withdraw your consent at any time. You can withdraw your consent at any time by contacting us by using the contact details provided in the section &quot;</span>
              <a href='#contact'>
                <span>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
              </a>
              <span>&quot; below.</span>
            </p>
            <p>
              <span>However, please note that this will not affect the lawfulness of the processing before its withdrawal, nor will it affect the processing of your personal information conducted in reliance on lawful processing grounds other than consent.</span>
            </p>
            <p>
              <span>If you have questions or comments about your privacy rights, you may email us at </span>
              <a href='mailto:hello@rogerserentill.com' target='_blank' rel='noreferrer' className='url'>hello@rogerserentill.com</a>
              <span>.</span>
            </p>
            <p>
              <strong>
                <span id="DNT">8. CONTROLS FOR DO-NOT-TRACK FEATURES</span>
              </strong>
            </p>
            <p>
              <span>Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track (&quot;DNT&quot;) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage no uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this privacy notice.</span>
            </p>
            <p>
              <strong>
                <span id="caresidents">9. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</span>
              </strong>
            </p>
            <p>
              <strong>
                <span>In Short:</span>
              </strong>
              <span></span>
              <em>
                <span>Yes, if you are a resident of California, you are granted specific rights regarding access to your personal information.</span>
              </em>
            </p>
            <p>
              <span>California Civil Code Section 1798.83, also known as the &quot;Shine The Light&quot; law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us using the contact information provided below.</span>
            </p>
            <p>
              <span>If you are under 18 years of age, reside in California, and have a registered account with Services, you have the right to request removal of unwanted data that you publicly post on the Services. To request removal of such data, please contact us using the contact information provided below and include the email address associated with your account and a statement that you reside in California. We will make sure the data is not publicly displayed on the Services, but please be aware that the data may not be completely or comprehensively removed from all our systems (e.g., backups, etc.).</span>
            </p>
            <p>
              <strong>
                <span id="policyupdates">10. DO WE MAKE UPDATES TO THIS NOTICE?</span>
              </strong>
            </p>
            <p>
              <em>
                <strong>
                  <span>In Short:</span>
                </strong>
                <span> Yes, we will update this notice as necessary to stay compliant with relevant laws.</span>
              </em>
            </p>
            <p>
              <span>We may update this privacy notice from time to time. The updated version will be indicated by an updated &quot;Revised&quot; date and the updated version will be effective as soon as it is accessible. If we make material changes to this privacy notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy notice frequently to be informed of how we are protecting your information.</span>
            </p>
            <p>
              <strong>
                <span id="contact">11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
              </strong>
            </p>
            <p>
              <span>If you have questions or comments about this notice, you may email us at </span>
              <a href='mailto:hello@rogerserentill.com' target='_blank' rel='noreferrer' className='url'>hello@rogerserentill.com</a>
              <span> or by post to:</span>
            </p>
            <p>
              <span>Roger Serentill Gené</span>
            </p>
            <p>
              <span>Av. de Lleida, 52</span>
            </p>
            <p>
              <span>Benavent de Segrià , Lleida 25132</span>
            </p>
            <p>
              <span>Spain</span>
            </p>
            <p>
              <strong>
                <span id="request">12. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</span>
              </strong>
            </p>
            <p>
              <span>Based on the applicable laws of your country, you may have the right to request access to the personal information we collect from you, change that information, or delete it in some circumstances. To request to review, update, or delete your personal information, please visit: </span>
              <a href='http://www.xerinola.io/support' target='_blank' rel='noreferrer' className='url'>http://www.xerinola.io/support</a>
              <span>.</span>
            </p>
          </div>
        </div>
      </div>
    </main>
    <Footer />
    </>
  )
}

export default Privacy
